module.exports = __webpack_public_path__ + "static/media/connect.83aaa479.svg";